import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

/**
 *
 * @interface
 * @param {React.ReactNode} children - The content that will trigger the tooltip on hover.
 * @param {any} title - The text to display in the tooltip.
 * @param {string} placement - The placement of the tooltip (e.g., 'top', 'bottom', 'left', 'right').
 * @param {any} className - The class to display in the tooltip.
 */
interface ToolTipProps {
    children: React.ReactElement;
    title: any,
    placement?: any;
    className?: any;
}

const AppTooltip: React.FC<ToolTipProps> = ({ children, title, placement, className }) => {

    const tooltip: React.ReactNode = <Tooltip className={className} id="tooltip">{title}</Tooltip>;

    return (
        <OverlayTrigger rootClose={true} rootCloseEvent="mousedown" trigger={["hover", "hover"]} overlay={tooltip} placement={placement || 'auto'}>
            {children}
        </OverlayTrigger>
    )
}

export default AppTooltip;